import React from 'react';
import { Platform, View } from 'react-native';
import { BottomBarDLSType, ColorTokens, FontSizeTokens, StepperTypeTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { Typography } from "../../typography/Typography";
import { Stepper } from "../../stepper/Stepper";
import { addCommasToNumber } from "../utils";
import BottomBar from "../../bottomBarDLS/bottomBarDLS";
import ThemeProvider from "@voltmoney/theme";
const LoanRenewalStatusScreen = ({ height, stepperData, renewalRequestDetailsList, triggerAction, doneAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const updatedAmount = renewalRequestDetailsList?.updatedCreditLimit;
    return (React.createElement(View, { style: { height: Platform.OS === "ios" ? height - 46 : height } },
        React.createElement(View, { style: { paddingTop: 24, paddingLeft: 16, paddingRight: 16 } },
            React.createElement(View, { style: [
                    {
                        padding: 16,
                        borderColor: colorMapping[ColorTokens.Grey_Chalk]
                    },
                    styles.container
                ] },
                React.createElement(Typography, { label: "Loan renewal request recieved", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { label: `₹${updatedAmount ? addCommasToNumber(updatedAmount) : 0}`, fontSize: FontSizeTokens.XXXXL, lineHeight: 40, fontWeight: "700", color: ColorTokens.Secondary_100 }))),
            stepperData &&
                React.createElement(View, { style: {
                        borderBottomLeftRadius: 12,
                        borderBottomRightRadius: 12,
                        borderLeftWidth: 1,
                        borderRightWidth: 1,
                        borderBottomWidth: 1,
                        borderColor: "#E4E7EC",
                        paddingTop: 24,
                        paddingHorizontal: 16,
                    } },
                    React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true }))),
        React.createElement(BottomBar, { btnLabel: 'Done', typeDLS: BottomBarDLSType.TYPE_A, onPress: async () => {
                await triggerAction({
                    ...doneAction
                });
            } })));
};
const styles = {
    container: {
        borderRadius: 12,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: 1,
        backgroundColor: '#FFF',
        shadowColor: 'rgba(0, 0, 0, 0.04)',
        shadowOffset: { width: 0, height: 11 },
        shadowRadius: 10.6,
        elevation: 2, // Elevation for Android shadow
    }
};
export default LoanRenewalStatusScreen;
